const NO_WIDTH = 0

export enum KeyType {
  TimeOff = 'timeOff',
  Payroll = 'payroll',
  PendingPayroll = 'pendingPayroll',
  BlankSlate = 'blankSlate',
}

// We need the HEX color code for the Nivo Bar fillings
const keyColorMap = {
  [KeyType.TimeOff]: '#F5BA58', // champagne1000
  [KeyType.Payroll]: '#877FED', // purple1000
  [KeyType.PendingPayroll]: '#E1DFFA', // purple200,
}

export const keys = Object.keys(keyColorMap)
export const colors = Object.values(keyColorMap)

export const generateData = (
  totalTransfersTimeOff: number,
  totalTransfersCompensatedPayroll: number,
  totalTransfersPendingToCompensatePayroll: number
) => {
  if (
    totalTransfersTimeOff === 0 &&
    totalTransfersCompensatedPayroll === 0 &&
    totalTransfersPendingToCompensatePayroll === 0
  ) {
    return {
      timeOff: NO_WIDTH,
      payroll: NO_WIDTH,
      pendingPayroll: NO_WIDTH,
    }
  }
  return {
    timeOff: totalTransfersTimeOff,
    payroll: totalTransfersCompensatedPayroll,
    pendingPayroll: totalTransfersPendingToCompensatePayroll,
  }
}
